import React, {useState, useContext, useRef, useEffect} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides, IonSlide, IonFooter, IonCheckbox } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../../css/qavaApp.css';
import '../../../css/layout.css';

export function DeleteInventoryProductModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [globalProductID, setGlobalProductID] = useState(null);
    let [viewProductDetailsData, setViewProductDetailsData] = useState([]);
    let [searchResults, setSearchResults] = useState([]);
    let [inventoryAccessCheckboxValue, setInventoryAccessCheckboxValue] = useState(null);
    let [ProductManagementAccessCheckboxValue, setProductManagementAccessCheckboxValue] = useState(null);
    let [checkInCheckOutAccessCheckboxValue, setCheckInCheckOutAccessCheckboxValue] = useState(null);
    let [cleaningServicesAccessCheckboxValue, setCleaningServicesAccessCheckboxValue] = useState(null);
    let [productID, setProductID] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false)
    let [enteredPassword, setEnteredPassword] = useState('');

    let ProductNameRef = useRef('');
    let enterPasswordRef = useRef('');

    let salePriceRef = useRef('');
    let discountOfListRef = useRef('');
    let itemIDRef = useRef('');
    let productIDRef = useRef('');
    let productNameRef = useRef('');
    let productItemNameRef = useRef('');



    function deleteProduct(productID)
    {
    
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '33_deleteProduct',
                user: acctID,
                xInventoryProductID: productID,
                sessionID: sessionID,
            })
        }
    
        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {
    
            alert(data);

            setProductID(null);
            handleInput(['deleted_product', ""]);

        })
        .catch(error => {
            console.error(error);
        })
        
    }
    


    function searchProductList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchProductInDB(searchCategory, searchData);


    }

    function first_searchProductInDB(searchCategory, searchData, optionsData)
    {
        let formData = new FormData();
        //alert(searchData);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '33_searchDeleteProduct',
                user: acctID,
                xSearchData: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');
                                // alert(cols);
                                // alert(parseFloat(cols[8]).toFixed(2));
                                // alert(parseFloat(cols[9]).toFixed(2));


                                setSearchResults((prevSearchResults) => {
                                    return prevSearchResults.concat({
                                        productID: cols[0],
                                        productName: cols[1],
                                        productDescription: cols[2],
                                        productPartNum: cols[3],
                                        productPhoneNumber: cols[4],
                                        productCostPerUnit: parseFloat(cols[8]).toFixed(2),
                                        productSalePrice: parseFloat(cols[9]).toFixed(2),
                                        productPic1: cols[10],
                                        productPic2: cols[11],
                                        productPic3: cols[12],
                                        productPic4: cols[13],
                                        productDateCreated: cols[14],
                                        productAddedBy: cols[15],
                                        productIsActivated: cols[16],

                                    })
                                });


                                   // document.getElementById('deleteProductGrid').style.display = 'inline-block';
                            }

                    })
    }



        let timeout;

    function handleInput(event) {

        //alert(event);
        setSearchResults([]);

        clearTimeout(timeout); // Clear the previous timeout to reset the delay
        timeout = setTimeout(searchProductList(event), 2000); // Set a new timeout
    
    }

function setProductIDHandler(event) {


    if (productID === event) {
        
        // Deselect if the same item is clicked
        //alert("inside if produtID === event");

        setProductID(null);
        
    } else {
        //alert("inside if produtID != event");

        // Select the new item
        setProductID(event);
    }
};

function closeModalHandler() {

    props.closeModal(false);
}


    useEffect(() => {

        searchProductList(['initial_search', ""]);
    
    }, [])


    return (
        <React.Fragment>
        {
        props.openModal == true ?
        (
                <IonModal id='deleteInventoryProductModal' isOpen={ props.openModal}>
                    <IonHeader style={{color: "black"}}>
                    <IonGrid>
                        <IonRow>
                            <IonCol size='12'>
                                <IonText>DELETE PRODUCT</IonText>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonHeader>
                <IonContent className='grid_content'>

                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <label for='searchInventoryProduct_DeleteProduct'>Search Products For Deletion </label>
                                    <input type='text' id='searchInventoryProduct_DeleteProduct' ref={ productNameRef } placeholder='Search Inventory Product to Delete Product' onInput={() => handleInput(['delete_stock_product_item', productNameRef.current.value])} list='searchInventoryProduct_DeleteProductList' autocomplete='off' required></input>
                                    <datalist id='searchInventoryProduct_DeleteProductList'>
                                        {searchResults.map((result) => (
                                            <option key={result.productID} value={result.productName}></option>
                                        ))}
                                    </datalist>
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                        <div id='deleteProductGrid' style={{display: 'inline-block'}}>
                        <IonGrid >
                        <IonRow >
                                    <IonCol >ID</IonCol>
                                    <IonCol >Name</IonCol>
                                    <IonCol >Product Sale Price</IonCol>
                                    <IonCol >Action</IonCol>
                            </IonRow>
                            {searchResults.map((detailData) =>   {
                                return (
                                    <IonRow >
                                        <IonCol >{detailData.productID}</IonCol>
                                        <IonCol >{detailData.productName}</IonCol>
                                        <IonCol >{detailData.productSalePrice}</IonCol>
                                        <IonCol >
                                            <IonCheckbox checked={productID == detailData.productID} disabled={productID != null && productID != detailData.productID} className='small-button' onClick={() => setProductIDHandler(detailData.productID)}> DELETE </IonCheckbox>                         
                                        </IonCol>
                                    </IonRow>
                                )
                            }
                            )}
                        </IonGrid>
                        </div>

                </IonContent>
                <IonFooter className='grid_footer'>
                    <IonGrid>
                        <IonRow>
                            <IonCol size="6">
                                {(authenticatedMerchent_context.selectedTutorial?.tutorial_id == '11' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)
                                ?<IonButton className='modal_footer_button_left flash-tutorial' onClick={() => deleteProduct(productID)}> Confirm </IonButton> 
                                :<IonButton className='modal_footer_button_left' onClick={() => deleteProduct(productID)}> Confirm </IonButton>}
                                </IonCol>
                            <IonCol>
                                <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonFooter>
            </IonModal>) : null
                }
            </React.Fragment>

    )
}